import React, { useState, useRef } from 'react';

import desktop from '@/images/request-a-demo/desktop.svg';
import mobile from '@/images/request-a-demo/mobile.svg';

import { Links } from '@/utils/constants';
import * as styled from './Form.styled';

import { Loader } from './components/Loader';
import { InputField } from '../InputField';
import { Button, ButtonColors } from '../Button';

interface IFormData {
  data?: any;
  handleSubmit?: any;
  isLoading?: boolean;
}

interface IInput {
  placeholder?: string;
  type?: string;
  name?: string;
  value?: string;
  hidden?: boolean;
}

interface IForm {
  id?: string;
  inputs?: IInput[];
  formData?: IFormData;
  textareaText?: string;
  textareaSmall?: boolean;
  buttonText: string;
  buttonNotCenteredMedium?: boolean;
}

export const Form: React.FC<IForm> = ({
  formData,
  id,
  inputs,
  textareaText,
  textareaSmall,
  buttonText,
  buttonNotCenteredMedium,
}) => {
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(true);

  const formRef = useRef(null);

  const checkIfInputsAreNotEmpty = () => {
    let values: string[] = [];
    if (formRef?.current) {
      const childs = formRef.current.childNodes;
      childs.forEach((child) => {
        const input = child.getElementsByTagName('input')[0];
        if (input) {
          if (input.required) {
            values = [...values, input.value];
          }
        }
      });
    }
    if (values.some((val) => val === '')) {
      setButtonDisabled(true);
    } else {
      setButtonDisabled(false);
    }
  };

  return formData.data ? (
    <>
      <styled.ImageContainer>
        <styled.ImageBoxDesktop>
          <styled.Image src={desktop} />
        </styled.ImageBoxDesktop>
        <styled.ImageBoxMobile>
          <styled.Image src={mobile} />
        </styled.ImageBoxMobile>
        <styled.Caption>
          Stay connected!
          <br /> We will email you ASAP
        </styled.Caption>
      </styled.ImageContainer>
      <styled.ButtonBox buttonNotCenteredMedium={buttonNotCenteredMedium}>
        <Button to={Links.HOME} color={ButtonColors.SECONDARY}>
          Go Home
        </Button>
      </styled.ButtonBox>
    </>
  ) : (
    <styled.FormBox
      id={id}
      onSubmit={formData.handleSubmit}
      ref={formRef}
      onChange={checkIfInputsAreNotEmpty}
    >
      {inputs.map((input) => (
        <InputField
          key={input.name}
          type={input.type ? input.type : 'text'}
          name={input.name}
          value={input.value}
          hidden={input.hidden}
          labelToShow
        >
          {input.placeholder}
        </InputField>
      ))}
      <styled.TextAreaLabel>Your Message</styled.TextAreaLabel>
      <styled.TextArea
        maxLength={5000}
        name="message"
        placeholder={textareaText}
        textareaSmall={textareaSmall}
      />
      <styled.ButtonBox
        buttonNotCenteredMedium={buttonNotCenteredMedium}
        smaller={textareaSmall}
      >
        <Button
          type="submit"
          disabled={buttonDisabled}
          $leftIcon={formData.isLoading && <Loader inverted />}
        >
          {formData.isLoading ? 'Sending' : buttonText}
        </Button>
      </styled.ButtonBox>
    </styled.FormBox>
  );
};
